"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _difference2 = _interopRequireDefault(require("lodash/difference"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var _default = exports["default"] = function _default(form) {
  var exceptFields = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  (0, _difference2["default"])(Object.keys(form.getState().values), exceptFields).forEach(function (fieldName) {
    form.change(fieldName, null);
  });
};